<div
  class="flex min-h-svh w-full items-center justify-center p-[calc(var(--spacing)*6)] md:p-[calc(var(--spacing)*10)]"
>
  <div class="w-full" [class.max-w-sm]="size() === 'sm'" [class.max-w-md]="size() === 'md'">
    <section
      class="flex flex-col gap-[calc(var(--spacing)*6)] rounded-xl border border-border bg-card py-[calc(var(--spacing)*6)] text-card-foreground shadow-xs"
    >
      <header class="grid justify-items-center gap-[calc(var(--spacing)*3)] px-[calc(var(--spacing)*6)] text-center">
        @if (showLogo()) {
          <img class="size-[calc(var(--spacing)*10)] rounded-md" [src]="logoSrc()" [alt]="logoAlt()" />
        }
        <div class="grid gap-[calc(var(--spacing)*1)]">
          <h1 class="text-base font-medium leading-normal">{{ title() }}</h1>
          @if (description()) {
            <p class="text-sm text-muted-foreground">{{ description() }}</p>
          }
        </div>
      </header>

      <div class="px-[calc(var(--spacing)*6)]">
        <ng-content />
      </div>
    </section>
  </div>
</div>
